import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';

export const StyledButtonBlock = styled.article`
  margin: 3.5rem 0 4.5rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  h2 {
    font-size: 2.25rem;
    margin-bottom: 2rem;
  }

  a {
    margin: 0.5rem 2rem;
    width: 250px;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-top: 7rem 0 5rem;

    a {
      margin: 0 2rem;
    }
  }
`;